module.exports = __webpack_public_path__ + "static/media/logo300x300.5fe6ba1a.png";